import React from "react";
import { PageHero } from "../components/PageShells";
import GoogleReviews from "../components/GoogleReviews";
import ReviewsCarousel from "../components/ReviewsCarousel";

const Reviews = () => (
  <main data-testid="reviews-page">
    <PageHero
      eyebrow="Reviews"
      title="5.0 / 5 op basis van klantbeoordelingen."
      subtitle="We zijn er trots op dat onze klanten ons keer op keer aanbevelen aan vrienden en familie."
    />
    <GoogleReviews />
    <ReviewsCarousel />
  </main>
);

export default Reviews;
